import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { serverUrl } from '../../serverUrl';

// 🔹 Register User
export const registerUser = createAsyncThunk(
  'auth/registerUser',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await serverUrl.post('users/register/', userData);
      return response.data;
    } catch (error) {
      console.error('Registration Error:', error);

      // Safely extract the message
      const errorData = error.response?.data;
      let message = 'Something went wrong';

      if (errorData?.email && Array.isArray(errorData.email)) {
        message = errorData.email[0]; // ✅ first error message string
      } else if (errorData?.detail) {
        message = errorData.detail;
      }

      return rejectWithValue(message);
    }
  }
);

// 🔹 Login User
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await serverUrl.post('users/login/', formData);
      console.log('Login Response:', response.data);
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
      localStorage.setItem('role', response.data.role);
      localStorage.setItem('full_name', response.data.full_name);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Login failed');
    }
  }
);

// reset password
export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async (resetPasswordData, { rejectWithValue }) => {
    try {
      const { uidb64, token, new_password1, new_password2 } = resetPasswordData;

      const response = await serverUrl.post(`users/reset/${uidb64}/${token}/`, {
        new_password1,
        new_password2,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Password reset failed');
    }
  }
);

export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async (emailData, { rejectWithValue }) => {
    try {
      const response = await serverUrl.post(
        'users/forgot-password/',
        emailData
      );
      console.log('Forgot Password Response:', response.data);
      return response.data;
    } catch (error) {
      //   console.log('Forgot Password Error:', error.response?.data);
      return rejectWithValue(
        error.response?.data?.non_field_errors?.[0] || 'Request failed'
      );
    }
  }
);

// 🔹 Slice
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    loading: false,
    error: null,
    isAuthenticated: !!localStorage.getItem('access_token'),
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    },
  },
  extraReducers: (builder) => {
    builder
      // Register
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Reset Password
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.loading = false;
        state.success = true; // indicate password reset succeeded
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
